function formatNumberLimit(rawValue, options) {
  const maxValue = Number(options && options.max != null ? options.max : Infinity)
  const decimalPlaces = Number(options && options.decimal != null ? options.decimal : 0)
  const allowNegative = Boolean(options && options.allowNegative)

  let value = rawValue == null ? '' : String(rawValue)
  value = value.replace(/[^\d.\-]/g, '')

  if (!allowNegative) {
    value = value.replace(/-/g, '')
  } else {
    value = value.replace(/(?!^)-/g, '')
  }

  if (value === '.') {
    value = '0.'
  }

  const dotIndex = value.indexOf('.')
  if (dotIndex !== -1) {
    const intPart = value.slice(0, dotIndex)
    const decimalPart = value.slice(dotIndex + 1).replace(/\./g, '')
    value = `${intPart}.${decimalPart}`
  } else {
    value = value.replace(/\./g, '')
  }

  if (decimalPlaces > 0 && value.includes('.')) {
    const parts = value.split('.')
    const limitedDecimal = parts[1].slice(0, decimalPlaces)
    value = `${parts[0]}.${limitedDecimal}`
  }

  const numberValue = Number(value)
  if (!Number.isNaN(numberValue) && Number.isFinite(maxValue) && numberValue > maxValue) {
    value = String(maxValue)
  }

  return value
}

export default {
  bind(el, binding) {
    const inputEl = el.querySelector('input') || el
    const options = binding && binding.value ? binding.value : {}

    const onInput = () => {
      const formatted = formatNumberLimit(inputEl.value, options)
      if (formatted !== inputEl.value) {
        inputEl.value = formatted
        inputEl.dispatchEvent(new Event('input'))
      }
    }

    const onBlur = () => {
      if (inputEl.value && inputEl.value.endsWith('.')) {
        inputEl.value = inputEl.value.slice(0, -1)
        inputEl.dispatchEvent(new Event('input'))
      }
    }

    el.__numberLimitInputHandler__ = onInput
    el.__numberLimitBlurHandler__ = onBlur

    inputEl.addEventListener('input', onInput)
    inputEl.addEventListener('blur', onBlur)
  },
  unbind(el) {
    const inputEl = el.querySelector('input') || el
    if (el.__numberLimitInputHandler__) {
      inputEl.removeEventListener('input', el.__numberLimitInputHandler__)
    }
    if (el.__numberLimitBlurHandler__) {
      inputEl.removeEventListener('blur', el.__numberLimitBlurHandler__)
    }
    delete el.__numberLimitInputHandler__
    delete el.__numberLimitBlurHandler__
  }
}



// WEBPACK FOOTER //
// ./src/directives/numberLimit.js